(function () {
  'use strict';
  const Base = customElements.get('amazon-pillow-customization');
  if (!Base || customElements.get('memate-banner-customization')) return;
  class MeMateBannerCustomization extends Base {
    render() {
      super.render();
      this.fabricButtons = [];
      const field = this.config.fields.find((item) => item.id === 'fabric');
      if (!field || !field.options.every((option) => option.image)) return;
      const { wrapper, control } = this.nodes.get(field.id);
      const grid = this.element('div', 'memate-banner-fabric-grid');
      grid.setAttribute('role', 'group');
      grid.setAttribute('aria-label', field.label);
      for (const option of field.options) {
        const button = this.element('button', 'memate-banner-fabric-card');
        button.type = 'button';
        button.setAttribute('aria-pressed', 'false');
        button.dataset.fabricOption = option.id;
        const image = this.element('img');
        image.src = option.image;
        image.alt = '';
        image.width = 120;
        image.height = 120;
        image.loading = 'lazy';
        const suffix = option.priceCents ? ` (+${this.money(option.priceCents)})` : '';
        button.append(image, this.element('span', 'memate-banner-fabric-label', option.label + suffix));
        button.addEventListener('click', () => {
          control.value = option.id;
          control.dispatchEvent(new Event('change', { bubbles: true }));
        });
        grid.append(button);
        this.fabricButtons.push({ button, option });
      }
      wrapper.append(grid);
    }
    update() {
      super.update();
      for (const { button, option } of this.fabricButtons || []) {
        button.setAttribute('aria-pressed', String(this.state.fabric === option.id));
      }
      if (this.fabricButtons?.length) this.nodes.get('fabric').image.hidden = true;
    }
  }
  customElements.define('memate-banner-customization', MeMateBannerCustomization);
})();
